<template>
  <a-drawer
    :width="this.driverId?width:(width-289)"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :closable="false"
    :headerStyle="{paddingTop:'0px'}"
    :bodyStyle="{background:'rgba(244, 249, 253, 1)',padding: 0 }"
    :drawerStyle="{background:'rgba(244, 249, 253, 1)',overflowY:'hidden'}"
    @close="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <div class="worder-top">
        <div class="worder-title" @click="handleCancel">
          <img class="icon" src="@/assets/driver/arrow@2x.png"/>{{this.leftMap.b}}
        </div>

        <div class="right-btns">
          <span style="margin-right: 24px;color: rgba(125, 133, 146, 1);font-size: 16px" v-if="driverModel.cureStr">推荐线索：{{driverModel.cureStr}}</span>
          <span class="delete-order"  @click="handleCancel">
          <img class="icon" src="@/assets/driver/delete.png"/>
        </span>

        </div>
      </div>
      <div class="worder-content" :style="{marginLeft:this.driverId?'':'24px'}">
        <driver-info ref="driverInfo" style="width: 265px" v-if="this.driverId" :leftMap="leftMap" @close="closeByDel" @change="changeTab" @update="loadConfig" :model="driverModel"></driver-info>
        <div class="worder-info">
          <div class="worder-nav">
            <div class="worder-left">
              <span class="worder-f" v-if="leftMap.f" @click="changeTab({s:leftMap.f,f:'',leftTab:leftMap.fTable})">{{leftMap.f}}</span>
              <span style="color:rgba(10, 22, 41, 1) " v-if="leftMap.s">{{leftMap.f?'-':''}}{{leftMap.s}}</span>
            </div>
            <div v-if="leftMap.leftTab==3 &&  leftMap.page!='order'">
              <a-button type="primary" @click="newWorkOrder" style="height: 48px">新建工单</a-button>
            </div>
            <div v-else-if="leftMap.leftTab==1">
              <a-button type="primary" v-if="!disableSubmit && hasChangeFlag" style="margin-bottom: 0px; background: rgb(255, 0, 0); border: 1px solid rgb(255, 0, 0);height: 48px" @click="saveDriver">保存信息</a-button>
              <a-button type="primary" v-else-if="!disableSubmit && !hasChangeFlag" style="margin-bottom: 0px; background: #aaa; border: 1px solid rgb(255, 0, 0);height: 48px;">保存信息</a-button>
              <a-button type="primary" @click="disableSubmit = false;"  style="height: 48px"  v-else>编辑信息</a-button>
            </div>
            <div style="cursor: pointer" v-else-if="leftMap.leftTab==3 && leftMap.page=='order'">
              <a-dropdown :trigger="'click'" @visibleChange="showOperate=!showOperate" :overlayStyle="{width:'114px',textAlign:'center'}">
                <div class="operate-dropdown-menu operate-dropdown-menu-btn">
                  操作
                  <!--<a-icon :type="showOperate?'up':'down'"></a-icon>-->
                </div>
                <a-menu slot="overlay" class="user-dropdown-menu-wrapper">
                  <a-menu-item key="3" class="ant-dropdown-menu-item-new" @click="changeStatus('zj')" v-show="workOrder.workOrderStatus!=2">
                    <span>转交</span>
                  </a-menu-item>
                  <a-menu-item v-if="workOrder.workOrderStatus==1||workOrder.workOrderStatus==4"
                               key="4" @click="changeStatus('remark')" class="ant-dropdown-menu-item-new">
                    <span>挂起</span>
                  </a-menu-item>
                  <a-menu-item key="6" @click="changeStatus('js')" v-if="workOrder.workOrderStatus!=2 && (workOrder.isCreateBy || workOrder.isManager) " class="ant-dropdown-menu-item-new">
                    <span>结束</span>
                  </a-menu-item>
                  <a-menu-item key="8" @click="changeStatus('cq')" v-if="workOrder.workOrderStatus==2" class="ant-dropdown-menu-item-new">
                    <span>重启</span>
                  </a-menu-item>
                  <a-menu-item key="7" @click="changeStatus('delete')" v-if="workOrder.isManager" class="ant-dropdown-menu-item-new">
                    <span>删除</span>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </div>
            <div v-else-if="leftMap.leftTab==2">
              <a-button type="primary" @click="newCar" style="height: 48px">绑定车辆</a-button>
            </div>
            <div v-else-if="leftMap.leftTab==4">
              <a-button type="primary" @click="newPlatform" style="height: 48px">绑定平台</a-button>
            </div>
            <div v-else-if="leftMap.leftTab==5&& leftMap.page=='phone'">
              <a-button type="primary" @click="bdCall" style="height: 48px" v-if="callStatus!=1">绑定呼叫</a-button>
              <a-button type="primary"  style="height: 48px;background:rgba(228, 230, 232, 1) ;" v-else>绑定呼叫</a-button>
            </div>
            <div v-else-if="leftMap.leftTab==6 && checkHasPer('add:coupon')">
              <a-button type="primary" @click="newCoupon" style="height: 48px" >新增优惠卷</a-button>
            </div>
            <div v-else-if="leftMap.leftTab==7">
              <a-button type="primary" @click="newDriverFile" style="height: 48px">上传附件</a-button>
            </div>
          </div>
          <div class="worder-summary" v-if="leftMap.leftTab==3 && leftMap.page=='order'">
            <work-order-info ref="orderInfo" :dictOptions="dictOptions"  :model="workOrder" @load="loadWorkOrder"></work-order-info>
            <work-order-message :dictOptions="dictOptions" @change="loadWorkOrder" ref="orderMessage" @editWorkOrder="editWorkOrder" :model="workOrder"></work-order-message>
          </div>
          <div class="worder-summary"  v-if="leftMap.leftTab==1">
            <!--<driver-info-top :disabled.sync="disableSubmit" :model="driverModel"></driver-info-top>-->
            <dm-driver-modal-form ref="realForm" :form-data="driverModel" @ok="getInfo" @hasChange="hasChange"  @getData="getData" @getInfo="getInfo"  :disabled="disableSubmit"></dm-driver-modal-form>
          </div>
          <order-table style="margin-top: 24px" :form-data="{'workorderIngCount':driverModel.workorderIngCount,'workorderCount':driverModel.workorderCount}" v-if="leftMap.leftTab==3 && leftMap.page!='order'" :driverId="driverId" ref="orderTable" @showInfo="showInfo"></order-table>
          <car-table style="margin-top: 24px" v-if="leftMap.leftTab==2" :driverId="driverId" ref="carTable" @to="viewCarModel"></car-table>
          <platform-table style="margin-top: 24px" v-if="leftMap.leftTab==4" :driverId="driverId" ref="platformTable"></platform-table>
          <phone-table  style="margin-top: 24px" v-if="leftMap.leftTab==5 && leftMap.page!='phone'" :driverId="driverId" ref="phoneTable" @to="viewCallRecord"></phone-table>
          <div class="worder-summary" style="background: inherit"  v-if="leftMap.leftTab==5 && leftMap.page=='phone'">
            <call-top :model="phoneModel" @updatePhoneStatus="updatePhoneStatus"></call-top>
            <call-record-table style="margin-top: 24px"  :driverId="driverId" :phone="phoneModel.phone" ref="callTable"></call-record-table>
          </div>
          <coupon-table style="margin-top: 24px" @ok="callbackOk" :form-data="driverModel" v-if="leftMap.leftTab==6" ref="couponFile" :driverId="driverId"></coupon-table>
          <driver-file style="margin-top: 24px" v-if="leftMap.leftTab==7" ref="driverFile" :driverId="driverId"></driver-file>
        </div>
        <div class="worder-sjgk">
          <div class="worder-nav">
            <div class="worder-left">
              <span style="color:rgba(10, 22, 41, 1) ">数据概况</span>
            </div>
          </div>
          <workorder-info-top-new ref="ditn" v-if="leftMap.leftTab==3 && leftMap.page=='order'" :dictOptions="dictOptions"  :model="workOrder"></workorder-info-top-new>
          <driver-info-top-new :disabled.sync="disableSubmit" v-else  :model="driverModel"></driver-info-top-new>
        </div>
      </div>
      <dm-work-order-modal ref="orderForm" @ok="callbackOk"></dm-work-order-modal>
      <dm-zj-work-order-modal ref="zjOrder" @ok="callbackOk"></dm-zj-work-order-modal>
      <!--    <dm-platform-modal ref="platform" @ok="callbackOk" ></dm-platform-modal>-->
      <driver-platfrom-info ref="platform" @ok="callbackOk"></driver-platfrom-info>
      <call-modal ref="callModal" @ok="callbackOk" @close="zxhCall"></call-modal>
      <driver-file-modal ref="driverFileModal" @ok="callbackOk"></driver-file-modal>
      <car-new-info ref="carForm" @ok="callbackOk"></car-new-info>
      <add-coupon-modal ref="couponForm" @ok="callbackOk"></add-coupon-modal>
    </a-spin>
  </a-drawer>
</template>

<script>

import { httpAction, getAction,getFileAccessHttpUrl ,deleteAction} from '@/api/manage'
import {initDictOptions, filterDictText} from '@/components/dict/JDictSelectUtil'
import {ajaxGetDictItems,getDictItemsFromCache} from '@/api/api'
import DriverInfo from "../../../components/dm/driver/DriverInfo";
import { mixin, mixinDevice } from '@/utils/mixin.js'
import { returnCallTime } from '@/utils/util'
import WorkOrderMessage from "../../../components/dm/workorder/WorkOrderMessage";
import WorkOrderInfo from "../../../components/dm/workorder/WorkOrderInfo";
import DriverInfoTopNew from "../../../components/dm/driver/DriverInfoTopNew";
import DmDriverModalForm from "../../dm3/driver/modal/DmDriverForm";
import OrderTable from "../../../components/dm/workorder/OrderTable";
import DmWorkOrderModal from "../../dm3/workorder/modules/DmWorkOrderModal";
import CarTable from "../../../components/dm/car/CarTable";
import PlatformTable from "../../../components/dm/driver/PlatformTable";
import DmZjWorkOrderModal from "../../dm3/workorder/modules/DmZjWorkOrderModal";
//import DmPlatformModal from "../../dm/dirver/windows/DmPlatformModal";
import PhoneTable from "../../../components/dm/driver/PhoneTable";
import CallRecordTable from "../../../components/dm/driver/CallRecordTable";
import CallTop from "../../../components/dm/driver/CallTop";
import CallModal from "../../dm3/driver/modal/CallModal";
import DriverFile from "../../../components/dm/driver/DriverFile";
import DriverFileModal from "../../dm3/driver/modal/DriverFileModal";
import WorkorderInfoTopNew from "../../../components/dm/workorder/WorkorderInfoTopNew";
import CouponTable from "../../../components/dm/driver/CouponTable";
import AddCouponModal from "../coupon/modules/AddCouponModal";
import { checkHasPer } from "@/utils/authFilter"
import BackTab from "@comp/dm/BackTab.vue";
import DriverInfoTable from "@comp/dm/driver/DriverInfoTable.vue";
import DriverPlatfromInfo from "@views/dm4/DriverPlatfromInfo.vue";
import { Modal } from 'ant-design-vue'
export default {
  inject:['closeCurrent'],
  name: 'DriverNewInfo',
  mixins: [mixin, mixinDevice],
  components: {
    DriverPlatfromInfo,
    DriverInfoTable,
    BackTab,
    AddCouponModal,
    CouponTable,
    WorkorderInfoTopNew,
    DriverFileModal,
    DriverFile,
    CallModal,
    CallTop,
    CallRecordTable,
    PhoneTable,
    // DmPlatformModal,
    DmZjWorkOrderModal,
    PlatformTable,
    CarTable,
    DmWorkOrderModal,
    OrderTable,
    DmDriverModalForm,
    DriverInfoTopNew,
    WorkOrderInfo,
    // SendBox,
    WorkOrderMessage,
    DriverInfo,
    checkHasPer,
    CarNewInfo: () => import('../car/CarInfo'),
  },
  data () {
    return {
      disableSubmit:true,
      width:document.documentElement.clientWidth-((document.documentElement.clientWidth-430)>1308?420:252),
      confirmLoading:true,
      driverId:null,
      workOrderId:null,
      visible:false,
      contentHeight:826,
      leftMap:{
        leftTab:0,
        b:'返回司机列表'
      },
      dictOptions:{},
      workOrder:{},
      driverModel:{},
      checkHasPer:checkHasPer,
      op:{
        js:{
          type:2,
          workOrderStatus:2
        },
        cq:{
          type:3,
          workOrderStatus:1
        },delete:{
          url:'/dm/dmWorkOrder/delete',
          method:"DELETE"
        },zj:{
          type:1,
          workOrderStatus:1
        },remark:{
          type:4,
          workOrderStatus:4
        }
      },
      hasChangeFlag:false,
      phoneModel:{},
      bdHjStatus:1,
      style:{
        height:'48px',
        lineHeight:"36px"
      },
      showOperate:false
    }
  },activated () {
    // if(this.$route.query.id){
    //   let obj = {s:'基本信息',leftTab:1,b:'返回司机列表'};
    //   if(this.$route.query.orderId){
    //     obj = {f:"并联工单",s:'工单详情',page:'order',leftTab:3,fTable:3,b:'返回流转工单'};
    //   }
    //   this.showInfo(this.$route.query.orderId,this.$route.query.id,obj)
    // }else{
    //   this.addDriver();
    // }
  },created(){



  },
  methods: {
    edit(record){
      this.driverModel = record;
      if(this.driverModel.driverLabel && !this.driverModel.driverLabelStr){
        this.getLabel();
      }
      this.$nextTick(()=>{
        this.$refs.driverInfo.edit();
        if(this.leftMap.leftTab==1){
          this.hasChangeFlag = false;
          this.$refs.realForm.edit();
        }
        //this.$refs.driverInfoTable.init();
      })
    },
    async showInfo(workOrderId,driverId,leftMap){
      if(!leftMap.b){
        leftMap.b = this.leftMap.b;
      }
      this.leftMap = leftMap;
      this.visible = true;
      this.driverId = driverId;
      this.workOrderId = workOrderId;
      this.workOrder = {}
      await  this.loadConfig(1);

    },clear(){
      this.workOrder = {}
      this.driverModel = {};
      this.driverId = null;
      this.workOrderId = null;
    },
    async addDriver(){
      this.leftMap = {
        leftTab:1,
        s:"基本信息",
        b:"返回司机列表"
      }
      this.visible = true;
      this.clear();
      await this.loadConfig()
      this.disableSubmit = false;
      this.confirmLoading = false;
    },changeTab(leftMap){
      if(leftMap.leftTab!=1 && this.leftMap.leftTab==1 && this.hasChangeFlag){

        this.checkDriverInfo(this.saveDriver,null,this.changeTabSure,leftMap);

      }else{
        this.changeTabSure(leftMap)
      }

    },changeTabSure(leftMap){
      if(!leftMap.b){
        leftMap.b = this.leftMap.b;
      }
      this.leftMap = leftMap;
      this.loadConfig();
    },checkDriverInfo(back,backParam,close,closeParam){
      this.$confirm({

        title: '提示',
        okText: '确认',
        cancelText: '取消',
        content: '信息已修改，是否保存？',
        onOk: () => {
          if(back){
            back(backParam);
          }
        },
        onCancel: () => {
          if(close){
            close(closeParam)
          }
        }
      })
    },async loadConfig(t){
      if(this.leftMap.leftTab==3 && this.leftMap.page=='order'){
        this.contentHeight = document.documentElement.clientHeight-116;
        if(t){
          await this.initDictConfig();
        }
        await  this.loadWorkOrder();
      }else if(this.leftMap.leftTab==1){
        this.disableSubmit = true;
        this.hasChangeFlag = false;
      }else if(this.leftMap.leftTab==3){
        this.$nextTick(()=>{
          this.$refs.orderTable.loadList();
        })
      }else if(this.leftMap.leftTab==2){
        this.$nextTick(()=>{
          this.$refs.carTable.loadList();
        })
      }else if(this.leftMap.leftTab==4){
        this.$nextTick(()=>{
          this.$refs.platformTable.loadList();
        })
      }else if(this.leftMap.leftTab==5){
        if(!this.leftMap.page){
          this.$nextTick(()=>{
            this.$refs.phoneTable.loadList();
          })
        }else{
          this.$nextTick(()=>{
            this.$refs.callTable.loadList();
          })
        }

      }else if(this.leftMap.leftTab==6){
        this.$nextTick(()=>{
          this.$refs.couponFile.loadList();
        })

      }else if(this.leftMap.leftTab==7){
        this.$nextTick(()=>{
          this.$refs.driverFile.loadList();
        })
      }
      if(t){
        this.getInfo()
      }else{
        this.getDriverInfo();
      }
      if(this.leftMap.leftTab!=3 && this.leftMap.page=='order'){
        this.leftMap.page='';
      }
      if(this.leftMap.leftTab!=5 && this.leftMap.page=='phone'){
        this.leftMap.page='';
      }
      console.log(this.leftMap)
    },getDriverInfo(){
      if(this.driverId && (!this.driverModel || Object.keys(this.driverModel).length==0)){
        this.getInfo();
      }else{
        if(this.leftMap.leftTab==1){
          this.$nextTick(()=>{
            this.$refs.realForm.edit();
          })
        }

      }
    },handleOk(){

    },callbackOk(){
      this.loadConfig(1);
    },callbackOkOrder(workOrderId){
      if(workOrderId){
        this.workOrderId = workOrderId;
      }
      this.workOrder = {};
      this.leftMap = {f:"并联工单",s:'工单详情',page:'order',leftTab:3,fTable:3,b:this.leftMap.b};
      this.confirmLoading = false;
      this.loadConfig();
    },handleCancel(){
      if(this.leftMap.leftTab==1 && this.hasChangeFlag){
        this.checkDriverInfo(this.saveDriver,null,this.closeTab,null);
      }else{
        this.closeTab()
      }
      this.$emit("ok");
    },closeTab(){
      this.visible = false;
    },closeByDel(){
      this.closeTab();
      this.$emit("ok")
    },
    initDictConfig(){
      //初始化字典
      initDictOptions('work_order_type').then((res) => {
        if (res.success) {
          this.dictOptions.work_order_type = res.result;
        }
      });
      initDictOptions('business_segment').then((res) => {
        if (res.success) {
          this.dictOptions.business_segment = res.result;
        }
      });
      initDictOptions('work_order_status').then((res) => {
        if (res.success) {
          this.dictOptions.work_order_status = res.result;
        }
      });
    },
    loadWorkOrder(isResh){
      getAction("/dm/dmWorkOrder/queryById",{"id":this.workOrderId,"isResh":isResh}).then((res)=>{
        if(res.success){
          this.workOrder = res.result;
          this.$nextTick(()=>{
            this.$refs.orderMessage.getDjs();
            this.$refs.orderMessage.toBottom();
            this.$refs.ditn.getLjsc();
          })
        }
      });
    },
    getInfo(driverId) {
      this.visible = true;
      if(driverId){
        this.driverId = driverId
      }
      this.confirmLoading = true;
      let params = {id: this.driverId};
      getAction("/dm/dmDriver/queryById", params).then((res) => {
        if (res.success) {
          this.driverModel = {};
          console.log(res.result)
          res.result.phoneStr = res.result.phone;
          this.disableSubmit = true;
          this.edit(res.result);
          this.confirmLoading = false;
        }
      })

    },getData(formData){
      let that = this;
      that.confirmLoading = true;
      let httpurl = '';
      let method = '';
      if(!formData.id){
        httpurl+="/dm/dmDriver/add";
        method = 'post';
        formData.hasChangeFlag = this.hasChangeFlag;
      }else{
        httpurl+="/dm/dmDriver/edit";
        method = 'put';
        formData.hasChangeFlag = this.hasChangeFlag;
      }

      that.loading = true
      httpAction(httpurl,formData,method).then((res)=>{
        if(res.success){
          that.$message.success("保存成功!");
          that.$emit('ok');
          that.disableSubmit = true;
          //that.getInfo(res.result.id);
          res.result.phoneStr = res.result.phone;
          if(res.result.id){
            this.driverId = res.result.id;
          }
          this.edit(res.result);
        }else{
          that.$message.warning(res.message);
        }
      }).finally(() => {
        that.loading = false;
        that.confirmLoading = false;
      })

    },saveDriver(){
      this.$refs.realForm.submitForm();
    },newWorkOrder(){
      this.$refs.orderForm.add([this.driverModel]);
    },editWorkOrder(record){
      console.log(record);
      this.$refs.zjOrder.add(record);
    },changeStatus(t){
      let formData = this.op[t];
      formData.id = this.workOrder.id+"";
      formData.ids = this.workOrder.id;
      if(t=='cq'){
        formData.transfer=this.workOrder.createBy
      }
      if(!formData.type){
        if(formData.method!='DELETE'){
          httpAction(formData.url,formData,formData.method).then((res)=>{
            if(res.success){
              this.loadWorkOrder(1);
              this.$message.success(res.message);
            }else{
              this.$message.warning(res.message);
            }
          })
        }else {
          Modal.confirm({
            title: '提示',
            content: '工单删除后不可恢复,是否继续操作？',
            okText: '继续',
            cancelText: '取消',
            okType: 'danger', // 确认按钮为危险样式（红色）
            icon: 'exclamation-circle', // 显示警告图标
            onOk: () => {
              deleteAction(formData.url, formData).then((res) => {
                if (res.success) {
                  this.changeTab({s: "并联工单", f: '', leftTab: 3})
                  this.$message.success(res.message);
                } else {
                  this.$message.warning(res.message);
                }
              })
            }
          });
        }
      }else{
        this.editWorkOrder(formData)
      }

    },
    async getLabel(){
      let dictOptions =""
      //优先从缓存中读取字典配置
      let cacheOption = getDictItemsFromCache("driver_label")
      if(cacheOption && cacheOption.length>0){
        dictOptions = cacheOption
        return this.formatLabel(dictOptions);
      }
      //根据字典Code, 初始化字典数组
      await ajaxGetDictItems("driver_label", null).then((res) => {
        if (res.success) {
          dictOptions = res.result;
          return this.formatLabel(dictOptions);
        }
      })
      return "";
    },formatLabel(dictOptions){
      let driverLabel = this.driverModel.driverLabel;
      driverLabel = driverLabel.split(",");

      let labStr = "";
      if(dictOptions){
        let labelMap = {}
        for(let lab in driverLabel){
          labelMap[driverLabel[lab]] = 1;
        }
        for(let dic in dictOptions){
          if(labelMap[dictOptions[dic].value]){
            labStr += ","+dictOptions[dic].text;
          }
        }
      }

      this.driverModel.driverLabelStr = labStr?labStr.substr(1):labStr;
      return labStr?labStr.substr(1):labStr;
    },viewCarModel(carId){
      this.$refs.carForm.showInfo(carId,{s:'基本信息',leftTab:1,b:'返回司机详情'})
    },newCar(){
      this.$refs.carForm.addCar(this.driverId);
      // this.$router.push({
      //   path: '/dm/car/carInfo',
      //   query:{
      //     driverId:this.driverId
      //   }
      // });
      // window.open("/dm/car/carInfo?driverId="+this.driverId)
    },newPlatform(){
      this.$refs.platform.addPlatform(this.driverId);
    },hasChange(chk){
      this.hasChangeFlag = chk;
    },viewCallRecord(record){
      this.phoneModel = record;
      this.leftMap.page = 'phone';
      this.leftMap.f = '号码列表';
      this.leftMap.s = "呼叫详情";
      this.leftMap.fTable = 5;
      console.log(this.leftMap)
      this.loadConfig();
      //this.checkBdStatus();
    },checkBdStatus(){
      // let p = Vue.ls.get("CALL_RECORD");
      // if(p){
      //   this.bdHjStatus = 0;
      //   return;
      // }
      let param = {
        driverPhone:this.phoneModel.phone,
        driverId:this.phoneModel.driverId
      }
      getAction("/dm/dmCallAxb/checkBdStatus",param).then((res)=>{
        if(res.success){
          this.bdHjStatus = res.result.bdFlag
        }
      });
    },bdCall(){
      let param={
        driverPhone:this.phoneModel.phone,
        driverId:this.phoneModel.driverId
      }
      getAction("/dm/dmCallAxb/bindAxbPhone",param).then((res)=>{
        if(res.success){
          res.result.driverName = this.driverModel.driverName;
          this.$refs.callModal.add(res.result);
          this.bdHjStatus = 0;
        }else{
          this.$message.warning(res.message);
        }
      });

    },zxhCall(){
      this.checkBdStatus();
    },updatePhoneStatus(model){
      this.phoneModel.phrases = model.phrases;
    },newDriverFile(){
      this.$refs.driverFileModal.add({
        driverId:this.driverId
      })
    },newCoupon(){
      this.$refs.couponForm.add({
        driverId:this.driverId
      })
    }
  }
}
</script>

<style lang="less" scoped>
/** Button按钮间距 */
.left-tab{
  height: 100%;
  background: rgba(244, 249, 253, 1);
}
.worder-top{
  background: rgba(244, 249, 253, 1);
  display: flex;
  justify-content: space-between;
  color: rgba(56, 56, 56, 1);
  padding-left:24px;
  margin-top: 24px;
  padding-right: 4px;
}
.worder-title{
  font-size: 24px;
  color: rgba(63, 140, 255, 1);
  cursor: pointer;
}
.worder-title .icon{
  width: 16px;
  height: 12px;
  margin-right: 6px;
  margin-top: -5px;
}
.right-btns{
  display: flex;
  align-items:center;
}

.right-btns .delete-order{
  padding: 0 10px;
  text-align: center;
  border-radius: 12px;
  cursor: pointer;
  margin-right: 20px;
  background: #fff;
  width: 44px;
  height: 44px;
  line-height: 44px;
}
.right-btns .delete-order img{
  width: 24px;
}
.right-btns .delete-order:hover{
  opacity: .8;
}

.worder-content{
  display: flex;
  margin: 24px 24px 0 0;
  gap: 24px;
  /*overflow-y: scroll;*/
  /*height: 706px;*/
}
.worder-nav{
  display: flex;
  justify-content: space-between;
}
.worder-nav .worder-left{
  font-size: 22px;
  line-height: 48px;
}
.worder-f{
  cursor: pointer;
  color: rgba(63, 140, 255, 1);
}

.worder-date{
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 6px 58px  rgba(196, 203, 214, 0.1);
  text-align: center;
  line-height: 44px;
}
.worder-date img{
  width: 24px;
  height: 24px;
}

.worder-content .worder-info{
  min-width: 600px;
  flex: 1;
}
.worder-summary{
  background: #fff;
  border-radius: 12px;
  margin-top: 24px;
}

.worder-summary-top-btn{
  width: 145px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  color: rgba(63, 140, 255, 1);
}
.worder-summary-top-btn img{
  width: 24px;
  height: 24px;
  cursor: pointer;
}
.worder-status-btn{
  width: 145px;
  height: 48px;
  line-height: 48px;
}
.worder-sjgk{
  width: 265px;
}
.ant-drawer-open{
  transform: inherit !important;
}

.ant-dropdown-menu-item-new{
  width: 114px !important;
  margin: 6px;
  height: 48px;
  border-radius: 12px;
  color: rgba(10, 22, 41, 1);
  font-size: 16px;
  text-align: center;
  line-height: 36px;
}

.user-dropdown-menu-wrapper{
  border-radius: 12px;
}
.operate-dropdown-menu{
  border-radius:12px;
  width: 114px;
  background: #fff;
  height: 72px;
}

.operate-dropdown-menu-btn{
  width: 114px;
  height: 48px;
  background: #3F8CFF;
  color: #fff;
  border-radius: 12px;
  text-align: center;
  line-height: 48px;
  font-size: 16px;
}
/*/deep/ .ant-select-dropdown-menu-item{*/
/*height:48px !important;*/
/*line-height:48px !important;*/
/*text-align:center;*/
/*margin:0 6px;*/
/*border-radius:12px;*/
/*font-size:16px;*/
/*color:rgba(10, 22, 41, 1);*/
/*}*/

/deep/ .worder-summary-top-btn .ant-select-selection--single{
  border: none !important;
  background: rgba(63, 140, 255, 1) !important;
  color: #fff;
  border-radius: 12px;
  height: 48px !important;
}
/deep/ .worder-summary-top-btn .ant-select-arrow{
  color: #fff;
}

/deep/  .iconp{padding:32px;}
/deep/ .ant-radio-button-wrapper{
  height:40px;
  line-height: 40px;
  border-radius: 8px;
}
/deep/ .ant-radio-button-wrapper:not(:first-child)::before{
  position:inherit !important;
  display:contents !important;
}
/deep/ .ant-space-item{
  width: 100%;
}
/deep/ .ant-card{
  background: #f0f2f5 !important;
}

/*/deep/ .ant-drawer-wrapper-body{*/
/*background: rgba(244, 249, 253, 1) !important;*/
/*overflow-y: hidden;*/
/*}*/
/deep/ .ant-table-body{
  /*overflow-x:hidden !important;*/
}
/deep/ .ant-drawer-content{
  overflow-y: hidden !important;
}

/deep/ .ant-btn {
  border: 1px solid rgba(230, 237, 245, 1) !important;
  width: 112px;
  border-radius:12px;
}
/deep/ .ant-select-selection__rendered{
  line-height: 48px !important;
}



</style>